"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountId = void 0;
function getAccountId(appDefId, appInstanceId) {
    return `${appDefId}:${appInstanceId}`;
}
exports.getAccountId = getAccountId;
//# sourceMappingURL=getAccountId.js.map